<div class="dialog">
  <h2 mat-dialog-title>{{ variables?.selectProfile || 'Seleccionar un perfil' }}</h2>

  <mat-dialog-content class="dialog-content">
    <div class="field-block">
      <label class="section-label">{{ variables?.currentProfile || 'Perfil Actual/Selecciondado' }}</label>
      <div class="current-profile-display">{{ currentProfileCenter }} - {{ currentProfileName }} {{ currentProfileCostPerHour }}€/h</div>
    </div>

    @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
    }

    @if (!isLoading && profiles.length > 0) {
    <div class="field-block">
      <label class="section-label mandatory"><span>*</span> {{ variables?.center || 'Centro' }}</label>
      <mat-form-field appearance="outline" class="form-field">
        <mat-select [(ngModel)]="selectedCenter" (selectionChange)="onCenterSelect($event.value)" placeholder="{{ variables?.center || 'Centro' }}">
          <mat-option [value]="null">
            {{ variables?.selectCostCenter || 'Seleccione un centro de coste.' }}
          </mat-option>
          @for (center of centers; track center) {
          <mat-option [value]="center">
            {{ center }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field-block">
      <label class="section-label mandatory"><span>*</span> {{ variables?.selectAProfile || 'Seleccionar un perfil' }}</label>
      <mat-form-field appearance="outline" class="form-field">
        <mat-select
          [(ngModel)]="selectedProfileId"
          (selectionChange)="onProfileSelect($event.value)"
          [disabled]="!selectedCenter"
          placeholder="{{ variables?.selectProfile || 'Seleccionar perfil' }}">
          <mat-option [value]="null">
            {{ variables?.noProfile || 'Sin perfil' }}
          </mat-option>
          @for (profile of filteredProfiles; track profile.id) {
          <mat-option [value]="profile.id">
            {{ profile.name }} ({{ profile.costPerHour || 0 }}€/h)
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (selectedCenter && filteredProfiles.length === 0) {
      <div class="empty-state">
        {{ variables?.noProfilesFound || 'No se encontraron perfiles' }}
      </div>
      }
    </div>
    }

    @if (!isLoading && profiles.length === 0) {
    <div class="empty-state">
      {{ variables?.noProfilesAvailable || 'No hay perfiles disponibles' }}
    </div>
    }

  </mat-dialog-content>

  <div class="dialog-box-s">
    <mat-dialog-actions class="button-group">
      <app-button
        typeBtn="secondary"
        color="red"
        textColor="white"
        message="{{ variables?.cancel || 'Cancel' }}"
        (click)="onCancel()">
      </app-button>
      <app-button
        typeBtn="primary"
        [disabled]="isLoading"
        message="{{ variables?.confirm || 'Confirm' }}"
        (click)="onConfirm()">
      </app-button>
    </mat-dialog-actions>
  </div>
</div>
